/** Debe coincidir con server/db/registry.js NOT_CONFIGURED */
export const DATA_CONNECTION_NOT_CONFIGURED = 'DATA_CONNECTION_NOT_CONFIGURED';

export const NO_DATA_CONNECTIONS_MESSAGE =
  'Sin conexiones de BD para datos. Configúralas en Admin → Conexión BD.';

function responseLooksLikeNginxCustomerPage(data) {
  return typeof data === 'string' && data.includes('Customer without service');
}

export function isDataConnectionNotConfiguredError(error) {
  const data = error?.response?.data;
  if (data?.code === DATA_CONNECTION_NOT_CONFIGURED) return true;
  if (responseLooksLikeNginxCustomerPage(data)) return true;
  if (error?.response?.status === 503 && typeof data?.error === 'string') {
    return /conexi[oó]n.*(datos|base de datos)|sin conexiones/i.test(data.error);
  }
  return false;
}

/** Log claro en consola; devuelve true si el error ya fue explicado. */
export function logDataConnectionError(context, error) {
  if (isDataConnectionNotConfiguredError(error)) {
    console.warn(`⚠️ ${context}: ${NO_DATA_CONNECTIONS_MESSAGE}`);
    return true;
  }
  return false;
}
